export enum ApiErrorTypes {
  ACCESS_DENIED = 'access_denied',
  NOT_FOUND = 'not_found',
  SERVER_ERROR = 'server_error',
  OTHER_ERROR = 'global_error',
}
